
import { useState } from 'react';
import { spezie, biscotti } from '../../../mocks/products';

const ProductsGrid = () => {
  const [filter, setFilter] = useState<'tutti' | 'spezie' | 'biscotti'>('tutti');
  
  const allProducts = [...spezie, ...biscotti];
  const filteredProducts = filter === 'tutti' 
    ? allProducts 
    : filter === 'spezie' 
    ? spezie 
    : biscotti;

  return (
    <section className="py-16 bg-[#FAF8F5] min-h-screen">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-block px-6 py-2 border border-[#2D5016] rounded-full mb-6">
            <span className="text-[#2D5016] text-sm font-medium">I Nostri Prodotti</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-serif font-light text-[#2D5016] mb-4">
            Esplora la Nostra<br />Selezione Artigianale
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Ogni prodotto è selezionato con cura per garantire la massima qualità e autenticità
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-white rounded-full p-1 shadow-sm">
            <button
              onClick={() => setFilter('tutti')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                filter === 'tutti'
                  ? 'bg-[#2D5016] text-white'
                  : 'text-gray-600 hover:text-[#2D5016]'
              }`}
            >
              Tutti i Prodotti
            </button>
            <button
              onClick={() => setFilter('spezie')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                filter === 'spezie'
                  ? 'bg-[#2D5016] text-white'
                  : 'text-gray-600 hover:text-[#2D5016]'
              }`}
            >
              Spezie Bio
            </button>
            <button
              onClick={() => setFilter('biscotti')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                filter === 'biscotti'
                  ? 'bg-[#2D5016] text-white'
                  : 'text-gray-600 hover:text-[#2D5016]'
              }`}
            >
              Biscotti Bio
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-80 bg-gradient-to-br from-[#E8F5E9] to-[#F5F5DC] overflow-hidden">
                <img
                  src={product.immagine}
                  alt={product.nome}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 px-3 py-1 bg-[#C17A5B] text-white text-xs font-medium rounded-full">
                  {product.categoria}
                </div>
                {product.disponibile && (
                  <div className="absolute top-4 right-4 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                )}
              </div>

              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold text-[#2D5016] mb-2">
                  {product.nome}
                </h3>
                <p className="text-gray-600 text-sm mb-6 line-clamp-2">
                  {product.descrizione}
                </p>
                <a
                  href="mailto:info@azienda.com"
                  className="w-4/5 mx-auto block px-6 py-3 bg-black text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Info-disponibilità-prezzi x mail
                </a>
              </div>
            </div>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div className="text-center py-16">
            <i className="ri-inbox-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-gray-500 text-lg">Nessun prodotto trovato</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductsGrid;
